import { render, staticRenderFns } from "./ArrearageList.vue?vue&type=template&id=5c8aa3ae&scoped=true"
import script from "./ArrearageList.vue?vue&type=script&lang=js"
export * from "./ArrearageList.vue?vue&type=script&lang=js"
import style0 from "./ArrearageList.vue?vue&type=style&index=0&id=5c8aa3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8aa3ae",
  null
  
)

export default component.exports